// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sub-link[data-v-0f329d51] {\n  color: var(--interfaceFontColor, var(--text-gray-400));\n  font-family: var(--sidebarElementsFontTypeface, inherit);\n  font-weight: var(--sidebarElementsFontWeight, 700);\n}\n.item-link[data-v-0f329d51] {\n  color: var(--interfaceFontColor, var(--text-gray-600));\n  font-family: var(--sidebarElementsFontTypeface, inherit);\n  font-weight: var(--sidebarElementsFontWeight, 500);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
